import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, Button, Modal, ModalHeader, ModalBody } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useSelector, useDispatch } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

import moment from 'moment';
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';


const Dashboard = props => {
  //meta title
  document.title = "Dashboard";
  const dispatch = useDispatch();
	const location = useLocation();
  const { getRequest } = useRequests();

  const [modal_Fiat_Transaction, setmodal_Fiat_Transaction] = useState(false);
  function Fiat_Transaction() {
    setmodal_Fiat_Transaction(!modal_Fiat_Transaction);
    // removeBodyCss();
  }

  const [modal_Crypto_Transaction, setmodal_Crypto_Transaction] = useState(false);
  function Crypto_Transaction() {
    setmodal_Crypto_Transaction(!modal_Crypto_Transaction);
    // removeBodyCss();
  }



  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};
  

  const [Transaction, setTransaction] = React.useState([]);
  const [StandardModal1, setStandardModal1] = React.useState(false);
  const togStandardModal1 = async (elementData) => {
    setTransaction(elementData);
    setStandardModal1(true);
  }

  const [ DashboardNumbers, setDashboardNumbers ] = React.useState({});
  const handleLoadGetDashboardNumbers = async () => {
    const res = await getRequest('get-dashboard-numbers');
    if (res && res.code === 200) {
      setDashboardNumbers(res.data);
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }
  
  const [FilePath, setFilePath] = React.useState('');
  const [TransactionTBody, setTransactionTBody] = React.useState('');
  const handleT1Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.pct_id}</td>
        <td>{element.first_name}</td>
        <td>{element.last_name}</td>
        <td>{element.email}</td>
        <td>{element.token}</td>
        <td>{element.currency}</td>
        <td>{parseFloat(element.received_amount)} &nbsp;{element.currency}</td>
        <td>{moment(element.created_at).format('YYYY-MM-DD | HH:mm')}</td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.status === 'Pending' ? 'badge-soft-warning' : element.status === 'Approved' ? 'badge-soft-success' : 'badge-soft-danger')}>{element.status}</span></td>
        <td className="text-center">
          <span className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal1(element)}><i className="mdi mdi-eye"></i></span>
        </td>
      </tr>
    ));

    setTransactionTBody(tempTBody);
  }
  const handleLoadGetTransactionData = async () => {
    const res = await getRequest('get-property-crypto-transaction-data');
    if (res && res.code === 200) {
      handleT1Body(res.data.transaction);
      setFilePath(res.data.url);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="10" className="text-center">No records found</td>
                      </tr>);

      setTransactionTBody(tempTBody);
    }
  }
  React.useEffect(() => {
    handleLoadGetDashboardNumbers();
    handleLoadGetTransactionData();

    if (typeof location.state !== 'undefined' && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
		}
  }, []);


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Dashboard")} />
          <Row>
            <Col xs="12">
              <Row>
                <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="/user_management" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">Users</h5>
                          <h4 className="mb-0">{DashboardNumbers.total_users}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-user display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="/user_management" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">Active Users</h5>
                          <h4 className="mb-0">{DashboardNumbers.active_users}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-user-check display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="/user_management" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">Inactive Users</h5>
                          <h4 className="mb-0">{DashboardNumbers.inactive_users}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-user-x display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="/user_kyc" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">KYC Verified Users</h5>
                          <h4 className="mb-0">{DashboardNumbers.kyc_verified_users}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-check-shield display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>

                <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="/user_kyc" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">KYC Pending Users</h5>
                          <h4 className="mb-0">{DashboardNumbers.kyc_pending_users}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-user-check display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="/claim_fund" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">Claim Fund Requests</h5>
                          <h4 className="mb-0">{DashboardNumbers.claim_fund_requests}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-money display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="/transaction" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">No of Transactions</h5>
                          <h4 className="mb-0">{DashboardNumbers.no_of_transactions}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-list-ul display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="3" md="6">
                  <Card>
                    <CardBody className="pb-3">
                      <Link to="/withdrawal_request" className="d-flex flex-wrap">
                        <div>
                          <h5 className="card-title mb-3 me-2">Withdrawal Requests</h5>
                          <h4 className="mb-0">{DashboardNumbers.withdrawal_requests}</h4>
                        </div>
                        <div className="ms-auto align-self-end">
                          <i className="bx bx-transfer-alt display-4 text-light"></i>
                        </div>
                      </Link>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>

          <Card>
            <CardBody>
              <Col lg="12">
                <div className="mb-4 h4 card-title">Latest Transactions</div>
                <div className="table-rep-plugin">
                  <div className="table-responsive mb-0">
                    <table className="table mb-0" style={{ minWidth: '1200px' }}>
                      <thead className="table-light">
                        <tr>
                          <th>ID</th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Email ID</th>
                          <th>Tokens</th>
                          <th>Currency</th>
                          <th>Amount</th>
                          <th>Date</th>
                          <th>Status</th>
                          <th className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {TransactionTBody}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </CardBody>
          </Card>


          <Modal isOpen={StandardModal1} backdrop={'static'} centered className="transation" >
            <div className="modal-header">
              <h5 className="modal-title mt-0">Transaction Details</h5>
              <button type="button" onClick={(e)=>setStandardModal1(false)} className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p className="mb-3">ID : <span className="text-primary">{Transaction.pct_id}	</span></p>
              <p className="mb-3">First Name : <span className="text-primary">{Transaction.first_name}	</span></p>
              <p className="mb-3">Last Name : <span className="text-primary">{Transaction.last_name}</span></p>
              <p className="mb-3">Email ID : <span className="text-primary">{Transaction.email}</span></p>
              <p className="mb-3">Tokens : <span className="text-primary">{Transaction.token}	</span></p>
              <p className="mb-3">Currency : <span className="text-primary">{Transaction.currency}</span></p>
              <p className="mb-3">Amount : <span className="text-primary">{parseFloat(Transaction.received_amount)} {Transaction.currency} {parseFloat(Transaction.used_euro_wallet_amount) !== 0? <b>( {Transaction.used_euro_wallet_amount} EUR spent from euro wallet )</b> : '' }</span></p>
              <p className="mb-3">Date : <span className="text-primary">{moment(Transaction.created_at).format('YYYY-MM-DD | HH:mm')}</span></p>
              <p className="mb-3">Status : <span className="text-primary"><span className={"font-size-14 badge bg-secondary rounded-pill " + (Transaction.status === 'Pending' ? 'badge-soft-warning' : Transaction.status === 'Approved' ? 'badge-soft-success' : 'badge-soft-danger')}>{Transaction.status}</span></span></p>
              {Transaction.send_tx !== '' && Transaction.send_tx !== null?
              <p className="mb-3">Transaction Hash : <span className="text-primary"><br />{Transaction.send_tx}</span></p>
              : '' }
              {Transaction.transaction_proof !== '' && Transaction.transaction_proof !== null?
              <p className="mb-3">Transaction Proof : <span className="text-primary"><br /><a rel="noreferrer" target="_blank" href={`${process.env.REACT_APP_API_URL}${FilePath}${Transaction.transaction_proof}`} download={Transaction.transaction_proof}>{Transaction.transaction_proof}</a></span></p>
              : '' }
              {Transaction.transaction_information !== '' && Transaction.transaction_information !== null?
              <p className="mb-3">Transaction Information : <span className="text-primary"><br />{Transaction.transaction_information}</span></p>
              : '' }
            </div>
          </Modal>

        </Container>
      </div>

    </React.Fragment >
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);
